import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { ProductGrid } from '../product/ProductGrid';
import styles from './InfiniteScroll.module.scss';
const ChevronUp = () => (h("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    h("mask", { id: "mask0_2873_15371", style: "mask-type:alpha", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24" },
        h("rect", { width: "24", height: "24", fill: "#D9D9D9" })),
    h("g", { mask: "url(#mask0_2873_15371)" },
        h("path", { d: "M12.0005 10.4535L7.9275 14.5268C7.789 14.6651 7.61492 14.7359 7.40525 14.7393C7.19575 14.7424 7.0185 14.6716 6.8735 14.5268C6.72867 14.3818 6.65625 14.2061 6.65625 13.9998C6.65625 13.7934 6.72867 13.6178 6.8735 13.4728L11.3678 8.97852C11.5486 8.79785 11.7595 8.70752 12.0005 8.70752C12.2415 8.70752 12.4524 8.79785 12.6333 8.97852L17.1275 13.4728C17.2658 13.6113 17.3367 13.7854 17.34 13.995C17.3432 14.2045 17.2723 14.3818 17.1275 14.5268C16.9825 14.6716 16.8068 14.744 16.6005 14.744C16.3942 14.744 16.2185 14.6716 16.0735 14.5268L12.0005 10.4535Z", fill: "black" }))));
export function InfiniteScroll({ products, loading, layout, mode = 'auto', hasMore = false, onLoadMore, canLoadLess = false, onLoadLess, totalCount, filtersOpen = false, }) {
    const loaderRef = useRef(null);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    // Auto mode: load more when scrolled to bottom
    useEffect(() => {
        if (mode !== 'auto' || !hasMore || !onLoadMore || isLoadingMore)
            return;
        const handleScroll = () => {
            if (!loaderRef.current)
                return;
            const rect = loaderRef.current.getBoundingClientRect();
            if (rect.top < window.innerHeight && !isLoadingMore) {
                setIsLoadingMore(true);
                onLoadMore();
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [mode, hasMore, onLoadMore, isLoadingMore]);
    // Reset loading state when products change
    useEffect(() => {
        setIsLoadingMore(false);
    }, [products.length]);
    const handleLoadMore = () => {
        if (onLoadMore && hasMore && !isLoadingMore) {
            setIsLoadingMore(true);
            onLoadMore();
        }
    };
    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (h("div", null,
        h(ProductGrid, { products: products, loading: loading && products.length === 0, layout: layout, filtersOpen: filtersOpen }),
        hasMore && mode === 'auto' && (h("div", { ref: loaderRef, class: styles.autoSentinel }, isLoadingMore && h("span", { class: styles.spinner })))));
}
